// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U3xi","type":"styles_type__1DziA","choices":"styles_choices__3ck9t"};